import type * as api from '@gitbook/api-client';
import type { NavigationScreenState } from '@gitbook/app-navigation';
import type { HiveClient } from '@gitbook/hive-client';
import * as hiveCore from '@gitbook/hive-core';
import { getSuspense } from '@gitbook/util-suspense-cache';

/**
 * This function returns whether a comment is on a deleted node or page.
 */
export function isCommentOnDeletedNodeOrPage(
    comment: api.Comment,
    revision: hiveCore.Revision,
    hiveClient: HiveClient
): 'node' | 'page' | undefined {
    // Page deleted
    if (comment.target.page && !revision.pages[comment.target.page.id]) return 'page';

    // Node checks
    const nodeId = comment.target.node?.id;
    if (!nodeId) return;

    const pageId = comment.target.page?.id;
    const page = pageId ? revision.pages[pageId] : undefined;
    if (!page || !hiveCore.isRevisionPageDocument(page) || !page.document) return;

    const doc = getSuspense(hiveClient.store.getDocument(comment.target.space, page.document));
    const lookupId = nodeId.includes('row-') ? nodeId.split('-')[0] : nodeId;
    if (!doc?.getDescendant(lookupId)) return 'node';
}

export const getSpaceIdFromScreen = (screen: NavigationScreenState): string | undefined => {
    switch (screen.type) {
        case 'space':
            return screen.space;
        case 'change_requests':
            return screen.selected?.spaceId;
        default:
            return undefined;
    }
};

export const getChangeRequestIdFromScreen = (screen: NavigationScreenState): string | undefined => {
    switch (screen.type) {
        case 'space':
            return screen.changeRequest?.toString();
        case 'change_requests':
            return screen.selected?.changeRequestNumber?.toString();
        default:
            return undefined;
    }
};
